export default __webpack_public_path__ + "static/media/Da_Woman-01_1.e79abdc0.svg";